import { supabase } from "@/integrations/supabase/client"

export interface ClienteInfo {
  nome: string | null
  telefone: string | null
}

export interface CriterioCompacto {
  id: string
  nome: string
}

export interface CriterioFinding {
  criterio_id: string
  status: "ok" | "atencao" | "reprovado" | "na"
  observacoes: string | null
  custo_reparo: number | null
}

export interface DiagnosticoItemFill {
  titulo: string
  observacao: string | null
  urgencia: "ok" | "atencao" | "urgente"
}

interface FillAvaliacaoResponse {
  tipo: "avaliacao"
  criterios: CriterioFinding[]
  cliente: ClienteInfo
  mensagem: string
}

interface FillDiagnosticoResponse {
  tipo: "diagnostico"
  itens: DiagnosticoItemFill[]
  cliente: ClienteInfo
  mensagem: string
}

export async function preencherAvaliacao(
  transcricao: string,
  criterios: CriterioCompacto[],
  contextoAnterior?: string | null,
): Promise<{ criterios: CriterioFinding[]; cliente: ClienteInfo; mensagem: string }> {
  const { data, error } = await supabase.functions.invoke<FillAvaliacaoResponse>(
    "ai-fill-form",
    { body: { tipo: "avaliacao", transcricao, criterios, contexto_anterior: contextoAnterior ?? undefined } },
  )
  if (error) throw new Error(error.message || "Falha ao processar avaliação")
  if (!data) throw new Error("Resposta vazia")
  return { criterios: data.criterios, cliente: data.cliente ?? { nome: null, telefone: null }, mensagem: data.mensagem }
}

export async function preencherDiagnostico(
  transcricao: string,
  contextoAnterior?: string | null,
): Promise<{ itens: DiagnosticoItemFill[]; cliente: ClienteInfo; mensagem: string }> {
  const { data, error } = await supabase.functions.invoke<FillDiagnosticoResponse>(
    "ai-fill-form",
    { body: { tipo: "diagnostico", transcricao, contexto_anterior: contextoAnterior ?? undefined } },
  )
  if (error) throw new Error(error.message || "Falha ao processar diagnóstico")
  if (!data) throw new Error("Resposta vazia")
  return { itens: data.itens, cliente: data.cliente ?? { nome: null, telefone: null }, mensagem: data.mensagem }
}
